import React from "react";
import { Dropdown, ButtonGroup, Button } from "react-bootstrap";

const MultiActionDropdown = ({
  variant = "outline-primary",
  btnIcon = null,
  btnText = "Action",
  btnOnClick = () => {},
  menuOptions = [],
}) => {
  return (
    <Dropdown as={ButtonGroup} className="d-inline-flex" drop="down">
      {/* Primary Action Button */}
      <Button
        variant={variant}
        onClick={btnOnClick}
        className="px-3 d-flex align-items-center"
        style={{ height: "36px", fontSize: "0.8rem",borderColor: 'lightgrey',color: 'black',border: '1.5px solid lightgrey' }} // Custom height & font size
      >
        {btnIcon && <span className="me-2">{btnIcon}</span>}
        {btnText}
      </Button>

      <Dropdown.Toggle
        split
        variant={variant}
        className="px-3 border-start-0"
        id="dropdown-split-button"
        style={{ height: "36px", fontSize: "0.8rem", borderColor: "lightgrey", color: "black", border: '1.5px solid lightgrey' }} // Match same height
      />

      {/* Dropdown Menu - styled to stay within card */}
      <Dropdown.Menu
        align="end"
        className="shadow-sm mt-1"
        style={{
          zIndex: 1050, // Stay above card
          minWidth: "120px", // Uniform size
        }}
      >
        {menuOptions.map((item, idx) => (
          <Dropdown.Item
            key={idx}
            onClick={() => {
              if (item.onClick) item.onClick();
            }}
            className="d-flex align-items-center"
          >
            {item.icon && <span className="me-2">{item.icon}</span>}
            {item.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default MultiActionDropdown;
